import React from "react";

// components

export default function EstadisticaVisitantes() {
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3 className="font-semibold text-base text-gray-800">
                Visitas a la página
              </h3>
            </div>
            <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
              <button
                className="bg-indigo-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
              >
                Ver todo
              </button>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left">
                  Nombre de la página
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left">
                  Visitantes
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left">
                  Usuarios únicos
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left">
                  Porcentaje de rebote
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-left">
                  /Auto-Market/
                </th>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  4,569
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  340
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  <i className="fas fa-arrow-up text-green-500 mr-4"></i>
                  46,53%
                </td>
              </tr>
              <tr>
                <th className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-left">
                  /Auto-Market/index.html
                </th>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  3,985
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  319
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  <i className="fas fa-arrow-down text-orange-500 mr-4"></i>
                  46,53%
                </td>
              </tr>
              <tr>
                <th className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-left">
                  /Auto-Market/charts.html
                </th>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  3,513
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  294
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  <i className="fas fa-arrow-down text-orange-500 mr-4"></i>
                  36,49%
                </td>
              </tr>
              <tr>
                <th className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-left">
                  /Auto-Market/tables.html
                </th>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  2,050
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  147
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  <i className="fas fa-arrow-up text-green-500 mr-4"></i>
                  50,87%
                </td>
              </tr>
              <tr>
                <th className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4 text-left">
                  /Auto-Market/profile.html
                </th>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  1,795
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  190
                </td>
                <td className="border-t-0 px-6 text-gray-600 align-middle border-l-0 border-r-0 text-xs whitespace-no-wrap p-4">
                  <i className="fas fa-arrow-down text-red-500 mr-4"></i>
                  46,53%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
